import { Boxed } from "./Boxed.components";
import { Button } from "./Button.components";
import { Text } from "./Text.components";
import { Icon } from "./style";
import React from "react";

export const Plan = ({ plan, yearly }) => {
  return (
    <Boxed
      bColor="#fff"
      boxShadow="0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)"
      border="1px solid #ccc"
      maxWidth="420px"
      pad="28px"
      borderRadius="5px"
    >
      <Text fontSize="24px" align="center" color="#0E1E87" fontWeight="600">
        {plan?.type}
      </Text>
      <Text align="center" fontSize="14px">
        <span style={{ fontSize: "28px", fontWeight: "600", color: "#0E1E87", margin: '0 2px' }}>
          {yearly ? plan?.price * 12 : plan?.price}
        </span>
        Monthly
      </Text>
      <Boxed margin="15px auto" width="40%">
        <Button>Pay Now</Button>
      </Boxed>
      <Boxed>
        {plan?.pros?.map((p, index) => (
          <Boxed key={index} display="flex">
            <Icon className="icon-angle-right" />
            <Text fontSize="16px">{p}</Text>
          </Boxed>
        ))}
      </Boxed>

    </Boxed>
  );
};
